import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
import openUserStories from '../openUserStories';

/**
 * "<user> mentioned you in their story".
 *
 * Opens the mentioning user's stories; the visibility rules still apply, so a
 * story the recipient may not see simply won't be there.
 */
export default class StoryMentionedNotification extends Notification {
  icon() {
    return 'fas fa-at';
  }

  href() {
    // The story belongs to whoever wrote it and lives behind the stories
    // endpoint rather than a route — onclick opens the viewer. This only has
    // to be a path core can inspect for its external-link check.
    return app.route('index');
  }

  /**
   * Core wires its own markAsRead to the notification link, so there is no
   * onclick hook to implement — the story is opened by extending that.
   */
  markAsRead(e) {
    if (e) e.preventDefault();

    super.markAsRead();

    const user = this.attrs.notification.fromUser();

    if (user) openUserStories(user);
  }

  content() {
    return app.translator.trans('happydigital-stories.forum.notifications.story_mentioned', {
      // The model itself, not its name: Flarum runs a {user} parameter through
      // its username helper, which calls displayName() and renders "[deleted]"
      // on its own when the account is gone.
      user: this.attrs.notification.fromUser(),
    });
  }

  excerpt() {
    return null;
  }
}
